import { useMemo } from 'react';

import { useAdminGetDeliveryZones } from '../../delivery-zones/hooks/admin-get-delivery-zones.hook';
import { DeliveryZoneRow } from '../../delivery-zones/types/delivery-zone.type';
import { LIVE_DELIVERY_ZONES_REQUEST } from '../constants/delivery-city-filters.constants';
import { sortDeliveryZoneOptions } from '../utils/delivery-zone-options.util';

type UseLiveDeliveryZoneOptionsResult = {
  isLoading: boolean;
  zoneOptions: DeliveryZoneRow[];
};

export function useLiveDeliveryZoneOptions(): UseLiveDeliveryZoneOptionsResult {
  const { isLoading, deliveryZones } = useAdminGetDeliveryZones(LIVE_DELIVERY_ZONES_REQUEST);
  const zoneOptions = useMemo(() => sortDeliveryZoneOptions(deliveryZones), [deliveryZones]);

  return { isLoading, zoneOptions };
}
